import { jsx as _jsx } from "react/jsx-runtime";
export const Icon = props => _jsx("span", { className: `icon ${props.iconClass}` });
